export default {
  render: function (createElement) {
    let remaining = this.$slots.default.length % this.qty;
    const columnItemsQty = parseInt(this.$slots.default.length / this.qty);
    const columns = [];
    for (let i = 0; i < this.qty; i++) {
      if (remaining > 0) {
        columns.push(
          createElement(
            'div',
            this.$slots.default.splice(0, columnItemsQty + 1),
          ),
        );
        remaining -= 1;
      } else {
        columns.push(
          createElement(
            'div',
            this.$slots.default.splice(0, columnItemsQty),
          ),
        );
      }
    }
    return createElement('div', columns);
  },
  props: {
    qty: {
      type: [String, Number],
    },
  },
};
